import { render, staticRenderFns } from "./I-0-2-1__IR-Default Messaging-Edit.vue?vue&type=template&id=3702ddba&"
import script from "./I-0-2-1__IR-Default Messaging-Edit.vue?vue&type=script&lang=js&"
export * from "./I-0-2-1__IR-Default Messaging-Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
